"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userActivityWithAssessmentScoreSchema = exports.userActivityPracticeWeekSchema = exports.userActivitySchema = void 0;
const zod_1 = require("zod");
const activity_1 = require("./activity");
const activityModule_1 = require("./activityModule");
exports.userActivitySchema = zod_1.z.object({
    _id: zod_1.z.string(),
    kind: activity_1.activityKindEnum,
    strategy: activity_1.activityStrategyEnum,
    display: activity_1.activityDisplaySchema,
    metadata: activity_1.activityMetadataSchema,
    finished: zod_1.z.boolean(),
    finishedAt: zod_1.z.date().optional(),
    index: zod_1.z.number(),
    module: activityModule_1.activityModuleSchema,
});
exports.userActivityPracticeWeekSchema = zod_1.z.object({
    dayOfWeek: zod_1.z.number(),
    totalDuration: zod_1.z.number(),
});
exports.userActivityWithAssessmentScoreSchema = zod_1.z.intersection(exports.userActivitySchema, zod_1.z.object({ assessmentScore: zod_1.z.number().nullish() }));
//# sourceMappingURL=userActivity.js.map